import moment from "moment";
import isNil from "lodash/fp/isNil";
class Controller {
  constructor($injector, Events, $stateParams, $state) {
    "ngInject";
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.Events = Events;
    this.Messages = $injector.get("Messages");
    this.Corporate = $injector.get("Corporate");
    this.onUpdate = this.Events.getUpdateEvent("corporateHoliday");

    this.CorporateHolidayTransforms = $injector.get(
      "CorporateHolidayTransforms"
    );
    this.errorEvent = Events.eventsType.onShowErrorNotification;

    this.showSuccessNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.minDate = moment().add(1, "days");
    this.searchText = "";
  }

  $onInit() {
    this.getCorporateDetails = () => {
      this.Corporate.getHolidayDetails(this.$stateParams.id).$promise.then(
        (response) => {
          this.holiday = this.CorporateHolidayTransforms.justify(response);
          this.selectedHolidaySchedule = this.holiday.schedules.filter(
            (schedule) => schedule.selected
          );
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    this.getCorporateDetails();

    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.onUpdateHandler = (item) => {
      const updatedItem = {};
      updatedItem[item.key] =
        typeof item.value !== "undefined"
          ? item.value
          : item.name
          ? item.name._id
          : null;
      updatedItem[item.key] =
        item.key === "date"
          ? moment(updatedItem[item.key]).format("YYYY-MM-DD")
          : item.value;

      const selectedSchedule = [];
      if (item.key === "schedules") {
        item.forEach((schedule) => {
          if (schedule.selected) selectedSchedule.push(schedule._id);
          updatedItem[item.key] = selectedSchedule;
        });
      }

      this.Corporate.updateHoliday(
        this.$stateParams.id,
        updatedItem
      ).$promise.then(
        () => {
          this.disableConfirm = true;
          this.holiday[item.key].isDisabled = true;
          this.getCorporateDetails();
          this.Events.emit(
            this.showSuccessNotificationEvent,
            this.Messages.updateMessage("corporate holiday", item.key)
          );
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };

    this.Events.on(this.onUpdate, this.onUpdateHandler);
    this.validateConfirm = () => {
      const selected = this.holiday.schedules.filter(
        (schedule) => schedule.selected
      );
      if (
        JSON.stringify(this.selectedHolidaySchedule) ===
        JSON.stringify(selected)
      ) {
        this.disableConfirm = true;
      } else this.disableConfirm = false;
    };
    this.selectAllSchedules = () => {
      if (!isNil(this.holiday.schedules)) {
        this.holiday.schedules.map((schedule) => {
          this.holiday.schedules.selectedAll
            ? (schedule.selected = false)
            : (schedule.selected = true);
          return schedule;
        });
      }
    };

    this.isAllChecked = () => {
      this.validateConfirm();
      const selected = this.holiday.schedules.filter(
        (schedule) => schedule.selected
      );
      return selected.length === this.holiday.schedules.length;
    };

    this.isIndeterminate = () => {
      const selected = this.holiday.schedules.filter(
        (schedule) => schedule.selected
      );
      return (
        selected.length !== 0 &&
        selected.length !== this.holiday.schedules.length
      );
    };

    this.getSelectedLength = () => {
      const selected = this.holiday.schedules.filter(
        (schedule) => schedule.selected
      );
      return selected.length;
    };

    this.onChangeSelectedSchedules = () => {
      this.validateConfirm();
      if (!isNil(this.holiday.schedules)) {
        const isAllSelected = this.holiday.schedules.every(
          (schedule) => schedule.selected
        );
        this.holiday.schedules.selectedAll = isAllSelected;
      }
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporateHoliday/corporateHoliday.controller.js